var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-rate",
        _vm._b(
          {
            ref: "rate",
            on: { change: _vm.handleChange },
            model: {
              value: _vm.initValue,
              callback: function ($$v) {
                _vm.initValue = $$v
              },
              expression: "initValue",
            },
          },
          "el-rate",
          Object.assign({}, _vm.item),
          false
        )
      ),
      _vm.item["show-auxiliary-text"]
        ? _c("div", { staticClass: "flex-row el-rate-text-wrap" }, [
            _c("p", { staticClass: "el-rate-text" }, [
              _vm._v(_vm._s(_vm.item.textLeft)),
            ]),
            _c(
              "p",
              {
                staticClass: "el-rate-text",
                staticStyle: { "text-align": "center" },
              },
              [_vm._v(_vm._s(_vm.item.textCenter))]
            ),
            _c(
              "p",
              {
                staticClass: "el-rate-text",
                staticStyle: { "text-align": "right" },
              },
              [_vm._v(_vm._s(_vm.item.textRight))]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }